import { useState, useEffect } from "react";
import { getAllTerms } from "@/helpers/taxonomy";
import DynamicStickyHeader from "../learning-pathways/dynamic-sticky-header";
import { useRouter } from "next/router";
import DetailsTab from "../learning-pathways/details-tabs";
import { convertMinutesToHoursAndMinutes } from "@/utils/convert-to-hours-and-minutes";
import useResponsive from "@/utils/hooks/Responsive-Screens";

export default function CenterContent({
  pageData,
  courseProgress,
  startCourse,
  isResponsive,
  handleFeedbackSubmit,
  isStandaloneCourse,
  inCompletedLessons,
  videoEntry,
  close,
  setClose,
  isLearningPath,
  duration,
  handleStartCourse,
}) {
  const data = pageData;
  const router = useRouter();
  const isLesson = router?.query?.lessons;
  const [loggedIn, setLoggedIn] = useState(false);
  const { isMobile } = useResponsive();

  const [term, setTerm] = useState(null);

  const getContentTypeTerm = async () => {
    const termsData = await getAllTerms("content_type");

    const terms = termsData.terms || [];
    const termsMap = new Map(terms.map((term) => [term.uid, term.name]));

    const taxonomies = data?.taxonomies?.length
      ? data.taxonomies.filter(
          (taxonomy) => taxonomy.taxonomy_uid === "content_type"
        )
      : [];

    const termUID = taxonomies.length ? taxonomies[0].term_uid : "";
    setTerm(termsMap.get(termUID));
  };

  useEffect(() => {
    let userData = localStorage.getItem("user");
    let parsedData;
    if (userData) {
      parsedData = JSON.parse(userData);

      if (parsedData?.email) {
        setLoggedIn(parsedData);
      }
    }
    getContentTypeTerm();
  }, []);

  const taxanomy_type = data?.taxonomies?.filter(
    (t) => t.taxonomy_uid === "content_type"
  );

  return (
    <div
      className="learning-path__container"
      style={{
        padding: isLesson ? (isMobile ? "0px 20px" : "0px 40px 40px 40px") : "",
      }}
    >
      <DynamicStickyHeader
        // learningPathwayDetails={data}
        isLearningPath={isLearningPath}
        courseDetails={videoEntry}
        duration={convertMinutesToHoursAndMinutes(duration, typeof duration)}
        term={term || taxanomy_type[0]?.term_uid}
        level={pageData?.right_rail?.expertise_levels}
        isStandaloneCourse={isStandaloneCourse}
        created_at={
          videoEntry?.publish_details?.time ||
          pageData?.right_rail?.release_date ||
          pageData?.created_at
        }
        isCompleted={courseProgress?.progress?.isCompleted}
        userData={courseProgress}
        handleStartCourse={handleStartCourse}
        isCourse={true}
        isLesson={isLesson}
        setClose={setClose}
        close={close}
        inCompletedLessons={inCompletedLessons && inCompletedLessons}
        redirectUrlPath={pageData?.chapters[0]?.lessons?.lessons[0]?.url}
        isCourseDetailsPage={true}
      />

      <DetailsTab
        data={data}
        overview={data.overview}
        // description={data.description}
        handleFeedbackSubmit={handleFeedbackSubmit}
        isStandaloneCourse={isStandaloneCourse}
        resources={data.right_rail.download_cta}
        pageData={pageData}
        faqs={data.faqs}
        isLesson={isLesson}
        videoEntry={videoEntry}
        transcriptData={videoEntry?.transcriptions_captions?.transcript}
      />
    </div>
  );
}
